import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { apiPlayerDetails } from '../Redux/Types';

interface userState {
	authenticated: boolean;
	username: string | undefined;
	emailAddress: string | undefined;
}

const initialState: userState = {
	username: undefined,
	emailAddress: undefined,
	authenticated: false
};

const userSlice = createSlice({
	name: 'userSlice',
	initialState,
	reducers: {
		login(_state, action: PayloadAction<apiPlayerDetails>) {
			return {
				...action.payload,
				authenticated: true
			};
		},
		logout() {
			return { ...initialState };
		}
	}
});

export const { login, logout } = userSlice.actions;

export default userSlice;
